'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PlusOutlined = _interopRequireDefault(require('./lib/icons/PlusOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _PlusOutlined;
exports.default = _default;
module.exports = _default;